/* src/app/builder-screen-beta/inspector/field-mapping-modal.component.scss */
.field-mapping-modal .modal-header {
  margin-bottom: 16px;
}
.field-mapping-modal .modal-header h3 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
}
.field-mapping-modal .modal-header .help-text {
  color: #8c8c8c;
  font-size: 12px;
  margin: 0;
  line-height: 1.5;
}
.field-mapping-modal .modal-content .mapping-list {
  max-height: 400px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.field-mapping-modal .modal-content .mapping-item {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 12px;
  transition: border-color 0.2s;
}
.field-mapping-modal .modal-content .mapping-item:hover {
  border-color: #d9d9d9;
}
.field-mapping-modal .modal-content .mapping-item .mapping-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}
.field-mapping-modal .modal-content .mapping-item .mapping-row .mapping-field {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.field-mapping-modal .modal-content .mapping-item .mapping-row .mapping-field .mapping-label {
  font-size: 11px;
  color: #595959;
  font-weight: 500;
}
.field-mapping-modal .modal-content .mapping-item .mapping-row .mapping-arrow {
  display: flex;
  align-items: center;
  padding-bottom: 4px;
  color: #bfbfbf;
  font-size: 16px;
}
.field-mapping-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
.field-mapping-modal .modal-footer .footer-info {
  margin-right: auto;
  font-size: 12px;
  color: #1890ff;
  font-weight: 500;
}
/*# sourceMappingURL=field-mapping-modal.component.css.map */
